import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { initialEvaluationForm } from 'pages/new-evaluation-form/evaluationFormSlice';

import { getQaEvaluationFormDetail } from 'services/qaSpec';

export const queryQaEvalFormKey = (productId, evaluationFormName) => {
  return ['pim', 'evaluation-form', parseInt(productId), evaluationFormName];
};

export const useQueryQaEvaluationForm = ({ productId, evaluationFormName }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: queryQaEvalFormKey(productId, evaluationFormName),
    queryFn: async () => {
      const response = await getQaEvaluationFormDetail({
        productId,
        evaluationFormName,
      });
      return response?.data ?? {};
    },
    refetchOnWindowFocus: false,
    enabled: Boolean(productId) && Boolean(evaluationFormName),
  });

  useEffect(() => {
    dispatch(
      initialEvaluationForm({
        values: query?.data,
        type: evaluationFormName,
      })
    );
  }, [query?.data, dispatch, evaluationFormName]);

  useEffect(() => {
    return () => {
      queryClient.removeQueries({
        queryKey: queryQaEvalFormKey(productId, evaluationFormName),
      });
    };
  }, [queryClient, productId, evaluationFormName]);

  return query;
};
